export default "__VITE_ASSET__Bbov12Qu__"